module.exports = __webpack_public_path__ + "static/bar-with-labels-41211b33d5199709542df6c7bbdbaf54.png";